import React from 'react';

import { get } from 'lodash-es';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { formatDDMMYYYHHMM } from '@common/Util';
import LanguageAndFlag from '@components/LanguageAndFlag/LanguageAndFlag';

const StyledBox = styled(Box)(({ theme }) => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

const StyledNoWrap = styled('span')(() => ({
  whiteSpace: 'nowrap'
}));

const ShowInterestHeader = ({ eventData, dialogHeader = false }) => {
  return (
    <>
      <StyledBox textAlign={dialogHeader ? 'left' : 'center'}>
        <Typography
          variant={dialogHeader ? 'h4' : 'body1'}
          display={dialogHeader ? 'block' : 'inline'}
          sx={{ mr: { xs: 0, sm: 2 } }}
        >
          {eventData?.name}
        </Typography>
        <Typography sx={{ paddingRight: { xs: 0, sm: '1rem' } }} display='inline'>
          {formatDDMMYYYHHMM(eventData?.startDateTime) + ' - '}
          <StyledNoWrap>{formatDDMMYYYHHMM(eventData?.endDateTime)}</StyledNoWrap>
        </Typography>
        <LanguageAndFlag nativeLanguages={get(eventData, 'nativeLanguages')} />
      </StyledBox>
    </>
  );
};
export default ShowInterestHeader;
